import { getOperatorPropertyLicenses } from '@/service/licensesService'
import type { FormattedOperatorWithLicense } from '@/types/operator'

import { createBaseTableStore } from '../table'
import type { FetchApiArgs, FetchApiResponse } from '../table/table.types'

export type LicensePropertyOperatorData = {
  id: number
  name: string
  email: string
  usersCount: number
  createdDate: string
  license: FormattedOperatorWithLicense['license']
}

const fetchLicensePropertyOperatorsApiCallback = async (
  args: FetchApiArgs<{ licenseProperty: string }, string, string>
): Promise<FetchApiResponse<LicensePropertyOperatorData>> => {
  const {
    signal,
    additionalParams: { licenseProperty }
  } = args

  const operators = await getOperatorPropertyLicenses(licenseProperty, signal)

  const operatorsData: LicensePropertyOperatorData[] = operators.map((operator) => ({
    id: operator.id,
    name: operator.name,
    email: operator.email || '',
    usersCount: operator.usersCount || 0,
    createdDate: operator.createdDate || '',
    license: operator.license
  }))

  return {
    content: operatorsData,
    totalElements: operatorsData.length
  }
}

export const useLicensePropertyStore = createBaseTableStore({
  storeName: 'License Property Operators',
  fetchApi: fetchLicensePropertyOperatorsApiCallback,
  features: {
    pagination: false,
    sorting: true,
    filtering: true
  }
})
